import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS, LabelXS } from '@sorare/core/src/atoms/typography';
import { PositionIcon } from '@sorare/core/src/components/lineup/PositionIcon';

import type { PlaceholderSlot_userCardCollectionSlot } from './__generated__/index.graphql.ts';

const CardWrapper = styled(Vertical).attrs({ center: true })`
  border-radius: var(--unit);
  overflow: hidden;
  position: relative;
  border: 1px solid var(--c-nd-50);
  gap: var(--unit);
  height: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  & > svg {
    color: var(--c-nd-600);
  }
`;

type Props = {
  slot: Nullable<PlaceholderSlot_userCardCollectionSlot>;
  small?: boolean;
  displayPlayerName?: boolean;
};

export const PlaceholderSlot = ({ slot, small, displayPlayerName }: Props) => {
  const { slot: collectionSlot } = slot || {};
  const { shirtNumber, displayName } = collectionSlot?.anyPlayer || {};
  const position = collectionSlot?.anyPlayer?.anyPositions?.[0];

  const Label = small ? LabelXS : LabelS;
  return (
    <CardWrapper>
      {position ? (
        <PositionIcon position={position} size={small ? 1.5 : 2} />
      ) : null}
      {typeof shirtNumber === 'number' && (
        <Label bold color="var(--c-nd-600)">
          #{shirtNumber.toString().padStart(2, '0')}
        </Label>
      )}
      {!!displayPlayerName && (
        <Label bold color="var(--c-nd-600)" className="text-center">
          {displayName}
        </Label>
      )}
    </CardWrapper>
  );
};

PlaceholderSlot.fragments = {
  userCardCollectionSlot: gql`
    fragment PlaceholderSlot_userCardCollectionSlot on UserCardCollectionSlot {
      slug
      slot {
        id
        anyPlayer {
          slug
          anyPositions
          shirtNumber
          displayName
        }
      }
    }
  ` as TypedDocumentNode<PlaceholderSlot_userCardCollectionSlot>,
};
